export const authentication = (state = {}, action) => {
  switch(action.type) {
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/authentication/javascripts/reducers/authentication.js